var giniView = /** @class */ (function () {
    function giniView() {
    }
    giniView.STORE_MODULE_NAME = 'finView';
    return giniView;
}());
export { giniView };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/giniView/lib/giniView.cls.ts
// module id = null
// module chunks = 